var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance,"backgroundColor":_vm.backgroundColor}},[_c('div',{class:[(_vm.$appPrefix + "-history-module")]},[_c('MgsContainer',[_c('MgsRow',[_c('MgsCol',[_c('div',{ref:"chart"})])],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }